// Profile tab endpoints (CHA-11134), mounted under /api/consumer-clarity/configure/.
// Thin transport only: URLs, params and bodies. Everything that translates
// between the wizard's `buildingBlocks` and the backend contract — flattening,
// phone (de)serialisation, error formatting — stays in ../constants/externalOps.

import { request } from "../../../../Services/Api"

const CONFIGURE_URL = "/consumer-clarity/configure"

// Only the read takes a business account: support admin's `?business_account_id`
// selects the merchant whose profile is shown (CHA1-1975), and a merchant's is
// ignored in favour of their session BA. The writes below deliberately take no
// such parameter — the server resolves every one of them against
// `request.user.current_business_account_id` and never reads the query string
// (chargeback_back consumer_clarity/views/configure.py), so accepting one here
// would only suggest support can write to the account they are viewing.
export const fetchConfigure = (businessAccountId) =>
  request.api.get(
    `${CONFIGURE_URL}/`,
    businessAccountId ? { business_account_id: businessAccountId } : undefined
  )

// §11.5 "Save for later" — completed steps plus the profile scoped to them.
export const postSaveDraft = (body) => request.api.post(`${CONFIGURE_URL}/save-draft/`, body)

// Step 3 first fill (CHA1-4909): descriptors and ARNs from Alerts, Stripe, Shopify and
// received alerts. Asked for separately because the integrations are slow to answer.
export const fetchPaymentIdentifierSuggestions = () =>
  request.api.get(`${CONFIGURE_URL}/payment-identifier-suggestions/`)

// §11.13 first submission — content is stored as the first version, descriptors
// and codes become enrollment requests for support.
export const postSubmit = (body) => request.api.post(`${CONFIGURE_URL}/submit/`, body)

// §11.13 subsequent edits — content only, one Profile update record per Active
// program (§11.14).
export const postProfileUpdate = (body) =>
  request.api.post(`${CONFIGURE_URL}/profile-update/`, body)

// Step 2 logo. Multipart; the response carries the attachment id that the next
// save/submit must send back as `profile.logo_id`.
export const postLogo = (formData) => request.api.post(`${CONFIGURE_URL}/logo/`, formData)
